import React from 'react';
import { connect } from 'react-redux';
import { Header } from 'components/header/header';
import { Logout } from 'components/logout/logout';
import { useRecordPageLogoutView } from './hooks/useRecordPageLogoutView';

const LogoutViewComponent = ({ products, userProfile }) => {
    useRecordPageLogoutView({ userProfile, products });

    return (
        <>
            <Header titleClass="hidden" />
            <div className="main-container messages-main-container basic-layering prospects-content">
                <Logout />
            </div>
        </>
    );
};

const mapStateToProps = state => ({
    userProfile: state.userProfile,
    products: state.products,
});

export const LogoutView = connect(mapStateToProps, null)(LogoutViewComponent);
